import { Controller } from '@hotwired/stimulus';

// Toggles a region cities table, fetching it the first time it is opened
export default class extends Controller {
  static targets = ['table', 'chevron'];
  static values = { url: String, error: String, loaded: Boolean };

  toggle = () => {
    this.tableTarget.classList.toggle('vesta-display-none');
    this.chevronTarget.classList.toggle('fa-chevron-up');
    this.chevronTarget.classList.toggle('fa-chevron-down');

    this.load();
  }

  load = async () => {
    if (this.loadedValue) return;

    this.loadedValue = true;
    this.tableTarget.innerHTML = "<i class='fas fa-spinner fa-pulse fa-2x'></i>";

    const response = await fetch(this.urlValue, { headers: { Accept: 'text/html' } });

    if (response.ok && !response.redirected) {
      this.tableTarget.innerHTML = await response.text();
    } else {
      this.loadedValue = false;
      this.tableTarget.innerHTML = '';
      alertMessage(this.errorValue, 'error');
    }
  }
}
